<!-- 作业列表 -->
<template>
  <div v-loading="loading">
    <el-row>
      <el-col :span="12" class="list_p">
        <p v-if="detailsData.workType==2">小组编号:{{detailsData.groupNo}}</p>
        <p v-for="(item,idx) in detailsData.workMemberVOS" :key="idx">
          <span>{{item.type==0?'小组成员':'组长名称'}}:{{item.licenseNo}}</span>
          <span style="padding-left:10px;">学号:{{item.studentName}}</span>
        </p>
        <p>状态:{{detailsData.status==1?'未提交':'已提交'}}</p>
        <p>提交时间:{{detailsData.committedDate}}</p>
        <p>
          作业文件:
          <router-link
           :to="`/alliance/teacher/${$route.query.schoolId}/homework/policyfile?strategyId=${detailsData.url}&userid=${detailsData.userId}`"
            v-if="detailsData.softwareType==1"
          >
            <span style="color: #2d8cf0;">AT作业文件跳转</span>
          </router-link>
          <router-link
            :to="`/alliance/hbue/teaching/student/homework/document?strategyId=${detailsData.url}&userid=${detailsData.userId}`"
            v-if="detailsData.softwareType==2"
          >
            <span style="color: #2d8cf0;">AFM作业文件跳转</span>
          </router-link>
          <!-- <span v-if="detailsData.softwareType==1">AT</span>
          <span v-if="detailsData.softwareType==2">AFM</span> -->
          <span v-if="detailsData.softwareType==3">其它</span>
        </p>
        <p>
          <span class="fl">附件:</span>

          <span
            v-if="detailsData.attachmentTOS"
            class="fl"
            style="margin-left: 10px;font-size: 14px;"
          >
            <a
              v-for="(item,idx) in detailsData.attachmentTOS||[]"
              :key="idx"
              :href="item.url"
              style="display:block;margin-bottom: 10px;"
            >{{item.name}}</a>
          </span>
        </p>
      </el-col>
      <el-col :span="12">
        <span style="vertical-align: top;">备注：</span>
        <rich-editor :value="detailsData.remark" ref="answer"></rich-editor>
      </el-col>
    </el-row>
    <div class="borderLi"></div>
    <el-row>
      <el-col :span="24">
        <el-radio-group v-model="radioList" @change="radioChange" v-if="detailsData.status!=3">
          <el-radio :label="2">
            手动评分
            <!-- <el-input v-model="manual" style="width:80px;" :disabled="radioList==1"></el-input> -->
             <el-input-number v-model="manual" controls-position="right" style="width:100px;" size="mini"
         :disabled="radioList==1" :min="0" :max="100"></el-input-number>
          </el-radio>
          <el-radio :label="1" v-if="detailsData.softwareType==1">
            自动评分
            <!-- <el-input v-model="voluntarily" style="width:80px;" :disabled="radioList==2"></el-input> -->
         <el-input-number v-model="voluntarily" controls-position="right" style="width:100px;" size="mini"
         :disabled="radioList==2" :min="0" :max="100"></el-input-number>

          </el-radio>
        </el-radio-group>
        <h3 class="listH3" v-else>
          分数:
          <span style="color:#02c45d;padding-left: 10px;">{{detailsData.score}}</span>
        </h3>
      </el-col>
      <el-col :span="24" style="margin-top: 20px;">
        <span style="display: inline-block;vertical-align: top;">评语：</span>
        <el-input
          type="textarea"
          :rows="3"
          placeholder="请输入评语"
          v-model="param.comment"
          style="width:450px;"
        ></el-input>
      </el-col>
    </el-row>
    <div style="margin: 20px 40px;" v-if="detailsData.status!=3">
      <el-button @click="save('back')">返回</el-button>
      <el-button @click="save('save')">保存</el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import richEditor from "@/components/common/RichEditor.vue";
export default {
   computed: {
    ...mapState(["user"])
  },
  components: {
    richEditor
  },
  props: {
    detailsData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      radioList: 2,
      voluntarily: null, // 自动
      manual: null, // 手动
      total: 0,
      homeworkList: [],
      loading: false,
      paramCourseWork: {
        courseWorkId: this.$route.query.courseWorkId,
        schoolId: this.$route.query.schoolId,
        status: 1
      },
      param: {
        comment: this.detailsData.comment,
        score: this.detailsData.score,
        studentWorkId: this.$route.query.courseWorkId
      }
    };
  },
  created() {
    // this.ngOnInit();
  },
  methods: {
    // 保存
    save(item) {
      this.param.score = this.radioList == 2 ? this.manual : this.voluntarily;
      this.param.studentWorkId = this.detailsData.studentWorkId;
      const param = {
        child: this.param,
        type: item
      };
      if (item == "back") {
        this.$emit("onSave", param);
        return;
      }
      if (!this.manual && this.radioList==2) {
        this.$message.error("评分不能为空");
        return;
      }
      if (!this.voluntarily && !this.radioList==1) {
        this.$message.error("评分不能为空");
        return;
      }
      this.$emit("onSave", param);
    },
    radioChange(item) {
      if (this.radioList == 1) {
        this.param.score = this.voluntarily;
        const param = {
          schoolId: this.$route.query.schoolId,
          studentWorkId: this.detailsData.studentWorkId
        };
        this.$api.allianceSchool.automaticGrading(param).then(res => {
          if (res.errCode == 0) {
            this.voluntarily = Number(Number(res.data).toFixed(2));
          } else {
            this.$message.error(res.errMsg);
          }
        });
      }
    },
    // 详情
    details(item) {
      this.$emit("onDetails", item);
    },
    // 页面初始化
    ngOnInit() {
      this.loading = true;
      this.$api.allianceSchool
        .queryWorkFinishStatus(this.paramCourseWork)
        .then(res => {
          this.loading = false;
          if (res.errCode == 0) {
            this.homeworkList = res.data || [];
            // this.total = res.total;
          } else {
            this.$message.error(res.errMsg);
          }
        })
        .catch(res => {
          this.loading = false;
        });
    }
  },
  mounted() {
    if (this.detailsData.softwareType == 2) {
      this.manual = this.detailsData.score;
    } else if (this.detailsData.softwareType == 1) {
      this.voluntarily = this.detailsData.score;
    }
  }
};
</script>
<style lang='less' scoped>
.list_p {
  p {
    height: 50px;
  }
}
.borderLi {
  border-top: 1px solid #ccc;
  height: 28px;
  text-align: center;
  margin: 14px auto;
}
.listH3 {
  font-weight: 300;
  color: #303133;
}
</style>